<template>
  <v-row class="mb-3 mr-1 ml-1">
    <v-col v-for="record in records" :key="record.id" align="center" cols="4" sm="4" md="4" lg="4" xl="2">
      <ClickableMovieCard :record="record"/>
    </v-col>
  </v-row>
</template>

<script>
import ClickableMovieCard from "@/components/ClickableMovieCard";
export default {
  name: "MovieWall",
  components: {ClickableMovieCard},
  props: ['records'],
  data: () => ({
    dialog: false,
  }),
  methods: {
    toMovieDetails(tmdb_id) {
      window.open('https://www.themoviedb.org/movie/' + tmdb_id + '?language=es-MX')
    }
  },
}
</script>

<style scoped>

</style>
